import { render } from "./Auth.vue?vue&type=template&id=7c083f90"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"
script.render = render

export default script